// structuredClone ist in Node ≥ 17 und allen modernen Browsern verfügbar.
declare function structuredClone<T>(value: T): T;

/** Tiefe Kopie des (rein JSON-kompatiblen) Spielzustands. */
export function deepClone<T>(value: T): T {
  return structuredClone(value);
}
